import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Icon, Row, Col, Tabs, Table, Input, Select, DatePicker, Form, Spin, message, Button, Modal } from 'antd';
import { Queries, Mutations } from '../../../graphql'
import Container from '../../../components/user/Container'
import FormInputAddress from '../../../components/user/FormInputAddress'
import TabsBlockProFile from '../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../config/datasetsProfile'
import { checkType } from '../../../utils/checkType'
import { changeFormatdateThai, pushAgeFullDate, changeFormatdate } from '../../../utils/formatdate'
import { numberWithCommas } from '../../../utils/number'
import { textStatus } from '../../../utils/childEducationFee'
import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const newsDataProfile = '';

class ChildEducationFee extends Component {
	state = {
		loadingFullPage:true,
        dataFetchList: [],
        columnsFetchList: [
            {
                title: '',
                dataIndex: 'childNo',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'บุตร',
                dataIndex: 'childFullName',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
			{
                title: 'วันเดือนปีเกิด',
				align:'center',
                dataIndex:'brithday',
                render: (item, record, index) => item ? changeFormatdateThai(item) : '-'
            },
			{
                title: 'อายุ(ปี:เดือน:วัน)',
				align:'center',
                dataIndex: 'brithday',
                render: (item, record, index) => item ? pushAgeFullDate(item) : '-'
            },
			{
                title: 'ระดับการศึกษา',
				align:'center',
                dataIndex: 'educationLevel',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ระดับชั้น',
                dataIndex: '7',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ประเภทสถานศึกษา',
                dataIndex: '7',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'สาขาวิชา',
                dataIndex: '7',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ปีการศึกษา',
                dataIndex: 'eduYear',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ภาคเรียน',
                dataIndex: '7',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ครั้งที่เบิก',
                dataIndex: '7',
				align:'center',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'คงเหลือเบิกได้',
                dataIndex: 'remainingTuition',
				align:'center',
                render: (item, record, index) =>  numberWithCommas(item) 
            },
            {
                title: 'จำนวนเงินตามเกณฑ์ที่เบิกได้',
                dataIndex: 'totalAmount',
				align:'center',
                render: (item, record, index) => numberWithCommas(item)
            },
            {
                title: '',
                dataIndex: '7',
				align:'center',
                render: (item, record, index) => <Icon type="eye" className="mr-2" style={{ color:"#000" }} onClick={ () => this.onChangeStepForm2(record) } />
            },
        ],
        loadingDataForm2:true,
        dataTalbeDataForm2: [],
        columnsDataForm2: [
            {
                title: 'เลขที่เอกสาร',
                dataIndex: 'documentNo',
                width:'200px',
				align:'center',
                render: (item, record, index) => item
            },
            // {
            //     title: 'ชื่อ-นามสกุล',
            //     dataIndex: 'childFullName',
            //     width:'200px',
			// 	align:'center',
            //     render: (item, record, index) => item
            // },
            {
                title: 'ระดับการศึกษา',
				align:'center',
                dataIndex:'educationLevel',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ระดับชั้น',
				align:'center',
                dataIndex:'eduGrade',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ประเภทสถานศึกษา',
				align:'center',
                dataIndex:'academyType',
                render: (item, record, index) => item ? item : '-'
            },
			{
                title: 'ปีการศึกษา',
				align:'center',
                dataIndex:'eduYear',
                render: (item, record, index) => item ? moment(item).year() : '-'
            },
            {
                title: 'ภาคเรียน',
				align:'center',
                dataIndex:'semaster',
                render: (item, record, index) => item ? item : '-'
            },
            {
                title: 'ครั้งที่',
				align:'center',
                dataIndex:'eduPeriod',
                render: (item, record, index) => item ? item : '-'
            },
			{
                title: 'จำนวนเงิน',
				align:'center',
                dataIndex: 'amount',
                render: (item, record, index) => numberWithCommas(item)
            },
			{
                title: 'สถานะ',
				align:'center',
                dataIndex: 'eduStatus',
                render: (item, record, index) => textStatus(item)
            },
            {
                title: 'วันที่จ่าย',
                dataIndex: '7',
                width:'200px',
				align:'center',
                dataIndex:'payDate',
                render: (item, record, index) => item ? changeFormatdate(item) : '-'
            },
            {
                title: '',
                dataIndex: '7',
				align:'center',
                dataIndex:'payDate',
                render: (item, record, index) => <Icon type="eye" className="mr-2" style={{ color:"#000" }} onClick={ () => this.onChangeStepForm3(record.tuitionDTID) }/>
            },
        ],
        stepForm: 1,
        arrayDropDownYear:[],
        childFullName: null,
        childNo: null,
        detailForm:null,
        dataTalbePeople: [],
        columnsPeople: [
            // {
            //     title: 'ลำดับ',
            //     dataIndex: 'docId',
            //     width:'8%',
			// 	align:'center',
            //     render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
            // },
            {
                title: 'วันที่ทำรายการ',
                dataIndex: 'transactionDate',
                width:'20%',
                align:'center',
                // render: (item, record, index) => <span>{moment(item).format('DD-MM-YYYY')}</span>
                render: (item, record, index) => <span>{changeFormatdate(item)}</span>
            },
            {
                title: 'ผู้ดำเนินรายการ',
                dataIndex: 'transactionBy',
                width:'200px',
				align:'center',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'สถานะ',
                dataIndex: 'status',
                width:'200px',
				align:'center',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'หมายเหตุ',
                dataIndex: 'remark',
                width:'200px',
				align:'center',
                render: (item, record, index) => <>
                    {
                        item ?
                            <span 
                                onClick={()=>{this.showModalNode(item)}} 
                                style={{ cursor:"pointer" }}
                            > 
                                อ่านหมายเหตุ
                            </span>
                        : '-'
                    }
                   
                </>
            },
        ],
        loadingColumnsPeople:false,
        showModalNote:false,
        noteModal:null,
        pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
        dataStep2: null
    }

    fetchListChildDetailInTuition = async () =>{
        const { client } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListChildDetailInTuition,
        })

        console.log('data.fetchListChildDetailInTuition', data.fetchListChildDetailInTuition)
        if(data.fetchListChildDetailInTuition){
            await this.setState({
                dataFetchList: data.fetchListChildDetailInTuition,
                loadingFullpage: false,
            })
        }else{
            await this.setState({
                loadingFullpage: false
            })
        }
    }

    onChangeStepForm1 = async () =>{
        await this.setState({
            loadingFullpage: true,
            stepForm: 1
        })
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
          });
        await this.fetchListChildDetailInTuition()
    }

    handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { childNo} = this.state
        // await this.setState({
        //     loadingDataForm2: true
        // })
		await e.preventDefault()
		form.validateFields(async (err, values) => {
            await this.setState({
                loadingDataForm2: true
            })
			if (!err) {
                try {
					const { data, errors } = await client.query({
						query: Queries.fetchEachChildTuitionDetail,
						variables: {
                            childNo,
							...values
						}
					})

					if(data.fetchEachChildTuitionDetail){
						await this.setState({
                            dataTalbeDataForm2: data.fetchEachChildTuitionDetail,
                            loadingDataForm2: false
						})
					}else{
						await this.setState({
                            dataTalbeDataForm2:[],
                            loadingDataForm2: false
						})
					}
                }catch (error) {
                    await this.setState({
                        loadingDataForm2: false
                    })
                }
			}
		})
	}

    fetchEachChildTuitionDetail = async (record) =>{
        const { client } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchEachChildTuitionDetail,
            variables: {
                childNo: record.childNo,
            }
        })

        if(data.fetchEachChildTuitionDetail){
            let arrayDropDownYear = [];

            console.log('data.fetchEachChildTuitionDetail',data.fetchEachChildTuitionDetail)
            
            data.fetchEachChildTuitionDetail.map((values, key)=>{
                arrayDropDownYear[values.eduYear] = moment(values.eduYear).year()
            })

            arrayDropDownYear.reverse()

            await this.setState({
                dataTalbeDataForm2: data.fetchEachChildTuitionDetail,
                loadingDataForm2: false,
                arrayDropDownYear
            })
        }else{
            await this.setState({
                loadingDataForm2: false
            })
        }
    }

    onChangeStepForm2 = async (record) =>{
        await this.setState({
            dataStep2: record,
            loadingDataForm2: true,
            childFullName: record.childFullName,
            childNo: record.childNo,
            stepForm: 2
        })
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
          });
        await this.fetchEachChildTuitionDetail(record)
    }

    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };

    fetchListChildTuitions = async (tuitionDTID) =>{
        await this.setState({
            loading: true
        })

        const { client, match } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListChildTuitions,
            variables: {
                tuitionDTID
            }
        })

        ////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        if(data.fetchListChildTuitions){
            await this.setState({
                loadingFullpage: false,
                detailForm: data.fetchListChildTuitions[0],
                loadingColumnsPeople: false,
                dataTalbePeople : data.fetchListChildTuitions[0].childTuitionHistory
            })
        }else{
            await this.setState({
                loadingFullpage: false,
                loadingColumnsPeople: false
            })
        }
    }

    onChangeStepForm3 = async (tuitionDTID) =>{
        await this.setState({
            loadingFullpage: true,
            loadingColumnsPeople: true,
            stepForm: 3
        })
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
          });
        await this.fetchListChildTuitions(tuitionDTID)
    }

    clearInput = async () =>{
		this.props.form.resetFields();
	}

	async componentDidMount(){
		await this.fetchListChildDetailInTuition()
    }

	render() {
		const { history, location, match, staticContext } = this.props
		const { getFieldDecorator } = this.props.form;
		const { 
            dataFetchList,
            loadingFullpage,
            columnsFetchList,
            stepForm,
            loadingDataForm2,
            dataTalbeDataForm2,
            columnsDataForm2,
            arrayDropDownYear,
            preLoadSubmit,
            childNo,
            childFullName,
            noteModal,
            showModalNote,
            detailForm,
            columnsPeople,
            dataTalbePeople,
            loadingColumnsPeople,
            dataStep2
         } = this.state

         console.log('dataTalbeDataForm2',dataTalbeDataForm2)
		return (
			<Container match={match}>
                <Modal
                    visible={showModalNote}
                    title={"หมายเหตุ"}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <p>{noteModal}</p>
                </Modal>
                <Spin spinning={loadingFullpage} delay={0}>
                    <div className="card-container" id="page-profile">
                        <div className="px-5 py-5 card-bg-green">
                            {
                                stepForm == 1 &&
                                    <>
                                        {
                                            dataFetchList.length > 0 ?
                                                dataFetchList.map((values, keys) =>{
                                                    return <>
                                                        <Row gutter={16} type="flex" justify="center" align="top" className="box-color-white" >
                                                            {
                                                                keys == 0 &&
                                                                    <Col xs={24} md={24} className="pt-2 mb-4">
                                                                        <strong className="color-red">
                                                                            รายการเบิกค่าการศึกษาบุตร
                                                                        </strong>
                                                                        <p style={{ fontSize:"14px", color:"#8d8d8d" }} className="mb-0">
                                                                            หมายเหตุ ระบบจะแสดงข้อมูลล่าสุดตามปัจจุบัน
                                                                        </p>
                                                                    </Col>
                                                            }
                                                            <Col span={24} className="mb-3">
                                                                <div style={{ display:"inline-block" }} className="pr-4" style={{ display:"inline-block", backgroundColor:"#fff", zIndex:"1", position:"relative" }}>
                                                                    <Title className="color-gray " level={4} style={{ position:"relative" }}>
                                                                        บุตรคนที่ { values.childNo }
                                                                    </Title>
                                                                </div>
                                                                <div className="line-center-div" style={{ borderColor:"#dcdcdc" }}></div>
                                                            </Col>
                                                            <Col span={12} className="mb-3">
                                                                <span style={{ fontSize:"12px", color:"#8d8d8d" }}>ชื่อ-นามสกุล</span>
                                                                {/* <p>{values.childFullName}</p> */}
                                                                <Input 
                                                                    value={ values.childFullName ? values.childFullName : '-' }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col span={12} className="mb-3">
                                                                <span style={{ fontSize:"12px", color:"#8d8d8d" }}>ระดับการศึกษา</span>
                                                                {/* <p>{ values.educationLevel+' '+values.eduGrade }</p> */}
                                                                <Input 
                                                                    value={ values.educationLevel ? values.educationLevel+' '+values.eduGrade : '-' }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col span={6} className="mb-3">
                                                                <span style={{ fontSize:"12px", color:"#8d8d8d" }}>ปีการศึกษา</span>
                                                                {/* <p>{values.eduYear}</p> */}
                                                                <Input 
                                                                    value={ values.eduYear ? moment(values.eduYear).year(): '-' }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col span={6} className="mb-3">
                                                                <span style={{ fontSize:"12px", color:"#8d8d8d" }}>ครั้งที่เบิก</span>
                                                                {/* <p>{ values.listNo }</p> */}
                                                                <Input 
                                                                    value={ values.listNo ? values.listNo : '-' }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col span={6} className="mb-3">
                                                                <span style={{ fontSize:"12px", color:"#8d8d8d" }}>คงเหลือเบิกได้</span>
                                                                {/* <p>{ numberWithCommas(values.remainingTuition) }</p> */}
                                                                <Input 
                                                                    value={ values.remainingTuition ? numberWithCommas(values.remainingTuition) : '-' }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col span={6} className="mb-3">
                                                                <span style={{ fontSize:"12px", color:"#8d8d8d" }}>จำนวนเงินตามเกณฑ์ที่เบิกได้</span>
                                                                {/* <p>{ numberWithCommas(values.totalAmount) }</p> */}
                                                                <Input 
                                                                    value={ values.totalAmount ? numberWithCommas(values.totalAmount) : '-' }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col span={24} align="right" className="mt-3">
                                                                {/* <Button 
                                                                    type="primary" 
                                                                    className="color-white" 
                                                                    htmlType="submit" 
                                                                    onClick={ () => this.onChangeStepForm2(values) }
                                                                > */}
                                                                <p
                                                                    onClick={ () => this.onChangeStepForm2(values) }
                                                                    style={{ textDecoration: "underline", cursor:"pointer", color:"blue" }}
                                                                >
                                                                    ดูรายละเอียด
                                                                </p>
                                                                {/* </Button> */}
                                                            </Col>
                                                            {/* <Col span={1} align="center">
                                                                <p className="mt-4">
                                                                    <Link
                                                                        to={{
                                                                            pathname: '/hospital/Withdraw/'+values.childNo
                                                                        }}
                                                                    >
                                                                        <Icon type="eye" className="mr-2" style={{ color:"#000" }}/>
                                                                    </Link>
                                                                </p>
                                                            </Col> */}
                                                        </Row>
                                                    </>
                                                })
                                            :
                                            <Row gutter={16} type="flex" justify="center" align="top" className="box-color-white" >
                                                <Col xs={24} md={24} className="pt-2 mb-4">
                                                    <strong className="color-red">
                                                        รายการเบิกค่าการศึกษาบุตร
                                                    </strong>
                                                </Col>
                                                <Col span={24} align="center">
                                                    <p>ไม่พบข้อมูลรายการ</p>
                                                </Col>
                                            </Row>
                                            }
                                    </>
                                || stepForm == 2 &&
                                    <>
                                        <div className="p-5" style={{ backgroundColor:"#fff" }}>
                                            <Form onSubmit={this.handleSubmit}>
                                                <Row gutter={16}>
                                                    <Col span={24} className="mb-4">
                                                    <Title level={4} className="color-blue-green">บุตรคนที่ { childNo } : { childFullName }</Title>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Form.Item label="เลือกปีการศึกษา" name="confirmpassword" >
                                                            { getFieldDecorator('eduYear', {
                                                                initialValue: 'A',
                                                                rules:  [{ 
                                                                    required:false,
                                                                    message: 'กรุณากรอกหรือเลือก วันที่ขอเบิก',
                                                                }],
                                                            })(
                                                                <Select 
                                                                    defaultValue="ทั้งหมด" 
                                                                    style={{ width: "100%" }} 
                                                                    // onChange={ this.filterType } 
                                                                    className="selectType"
                                                                >
                                                                    <Option value="A">ทั้งหมด</Option>
                                                                    {
                                                                        // arrayDropDownYear.length !== 0 &&
                                                                        arrayDropDownYear.map((values, key) =>{
                                                                            return <Option value={values.toString()}>{values}</Option>
                                                                        })
                                                                    }
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Form.Item label="สถานะ" name="confirmpassword" >
                                                            { getFieldDecorator('eduStatus', {
                                                                initialValue: 'A',
                                                                rules:  [{ 
                                                                    required:false,
                                                                    message: 'กรุณากรอกหรือเลือก วันที่ขอเบิก',
                                                                }],
                                                            })(
                                                                <Select 
                                                                    defaultValue="ทั้งหมด" 
                                                                    style={{ width: "100%" }} 
                                                                    // onChange={ this.filterType } 
                                                                    className="selectType"
                                                                >
                                                                    <Option value="A">ทั้งหมด</Option>
                                                                    <Option value="Y">อนุมัติ</Option>
                                                                    <Option value="N">ไม่อนุมัติ</Option>
                                                                    <Option value="W">รออนุมัติ</Option>
                                                                    <Option value="C">ยกเลิก</Option>
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} md={24} align={"right"}>
                                                        <Button type="primary" disabled={preLoadSubmit} className="mx-2 btn-white-red" onClick={this.clearInput}>
                                                            ล้างค่า
                                                        </Button>
                                                        <Button type="primary" disabled={preLoadSubmit} className="ml-2 color-white" htmlType="submit" >
                                                            ค้นหา
                                                        </Button>
                                                        {
                                                        preLoadSubmit &&
                                                            <Spin size="small" />
                                                        }
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                        <div className="pb-5 px-5" style={{ backgroundColor:"#fff" }} align={"center"}>
                                            <Table
                                                locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                                className="table-childEducationFee"
                                                dataSource={dataTalbeDataForm2} 
                                                columns={columnsDataForm2} 
                                                loading={loadingDataForm2}
                                                scroll={{ x: 'max-content' }}
                                                // pagination={{ pageSize: dataTalbe.length }}
                                            />
                                            <Button className="btn-white-red" onClick={ () => this.onChangeStepForm1() }>
                                                ย้อนกลับ
                                            </Button>
                                        </div>
                                    </>
                                 || stepForm == 3 &&
                                    <div className="p-5" style={{ backgroundColor:"#fff" }}>
                                        {
                                            detailForm ?
                                                <>
                                                    <Row gutter={16}>
                                                        <Col xs={24} md={24} className="pt-2 mb-4">
                                                            <strong className="color-red">
                                                                รายการเบิกค่าการศึกษาบุตร
                                                            </strong>
                                                        </Col>
                                                        <Col span={24} className="mb-3">
                                                            <span className="color-gray">เลขที่เอกสาร</span>
                                                            <Title className="color-blue-green mt-1" level={4} style={{ position:"relative" }}>
                                                                { detailForm.documentNo }
                                                                <span className={'ml-4 color-gray text-detail-status '+textStatus(detailForm.eduStatus,true)}>
                                                                    { textStatus(detailForm.eduStatus) }
                                                                </span>
                                                            </Title>
                                                            <p style={{ color:"#fa6c5c",display:"inline-block",width:"50%" }} className="mb-0">
                                                                    วันที่จ่าย : {  changeFormatdate(detailForm.payDate) }
                                                                </p>
                                                            {/* <span className="color-gray">
                                                                { changeFormatdate(detailForm.documentCreatedDate) }
                                                            </span> */}
                                                        </Col>
                                                        <Col span={24} className="mt-2" style={{ position:"relative" }}>
                                                            <div style={{ display:"inline-block" }} className="pr-4" style={{ display:"inline-block", backgroundColor:"#fff", zIndex:"1", position:"relative" }}>
                                                                <Title className="color-gray " level={4} style={{ position:"relative" }}>
                                                                    บุตรคนที่ { detailForm.childNo }
                                                                        {
                                                                            detailForm.academyType &&
                                                                            <p className="ml-3 mb-0" style={{ display:"inline-block", fontSize:"13px" }}>
                                                                                ประเภทสถานศึกษา {detailForm.academyType}
                                                                            </p>
                                                                        }
                                                                </Title>
                                                            </div>
                                                            <div className="line-center-div"></div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} className="mt-1">
                                                        <Col span={7}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ชื่อ - นามสกุล</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.childFullName ? detailForm.childFullName : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={7} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ระดับการศึกษา</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.educationLevel ? detailForm.educationLevel : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={3} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ระดับชั้น</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.eduGrade ? detailForm.eduGrade : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={4} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ปีการศึกษา</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.eduYear ? detailForm.eduYear : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={3} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ภาคเรียน</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.semaster ? detailForm.semaster : '-' }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} className="mt-4">
                                                        <Col span={24}>
                                                            <div className="mt-1">
                                                                <div align={"right"} style={{ display:"inline-block",width:"100%" }}>
                                                                    <p style={{ display:"inline-block"  }} className=" mb-0 mr-5">จำนวนเงิน</p>
                                                                    <p className="color-blue-green mb-0"  style={{ display:"inline-block" }}>
                                                                        {  numberWithCommas(detailForm.amount) }
                                                                    </p>
                                                                    <p  style={{ display:"inline-block"  }} className="mb-0 ml-3">บาท</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} type="flex" justify="left" align="top" className="mt-3" >
                                                        <Col xs={24} md={24} className="pt-2 mb-4">
                                                            <strong className="color-red">
                                                                ประวัติการอนุมัติค่าการศึกษาบุตร
                                                            </strong>
                                                            <Table
                                                                columns={columnsPeople}
                                                                dataSource={dataTalbePeople}
                                                                pagination={false}
                                                                loading={loadingColumnsPeople}
                                                                locale={{ emptyText: 'ไม่พบข้อมูล' }}
                                                                className="mt-4"
                                                                bordered
                                                                rowCount={dataTalbePeople.length}
                                                            />
                                                        </Col>
                                                        <Col md={24} className="pt-2 mb-4" align="center">
                                                            <Button className="btn-white-red" onClick={ () => this.onChangeStepForm2(dataStep2) }>
                                                                ย้อนกลับ
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                            :
                                            <Row gutter={16} className="mt-4">
                                                <Col span={24} align="center">
                                                    <p>ไม่พบข้อมูลรายละเอียดค่าการศึกษา</p>
                                                </Col>
                                            </Row>
                                            ||
                                            <Row>
                                                <Col align="center">
                                                    <Spin size="small" />
                                                </Col>
                                            </Row>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                </Spin>
			</Container>
		)
	}
}

ChildEducationFee.defaultProps = {
	autoFocus: false
}

ChildEducationFee.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedChildEducationFee = Form.create()(ChildEducationFee)

export default withApollo(WrappedChildEducationFee)